import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, UtensilsCrossed, QrCode, User, Grid3X3 } from 'lucide-react';

const navItems = [
  { path: '/owner', icon: Home, label: 'Home' },
  { path: '/owner/categories', icon: Grid3X3, label: 'Categories' },
  { path: '/owner/menu', icon: UtensilsCrossed, label: 'Menu' },
  { path: '/owner/qrcode', icon: QrCode, label: 'QR Code' },
  { path: '/owner/profile', icon: User, label: 'Profile' },
];

export default function OwnerLayout({ children, title }) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1 style={styles.title}>{title}</h1>
      </header>
      <main style={styles.main}>{children}</main>
      <nav style={styles.nav}>
        {navItems.map(({ path, icon: Icon, label }) => {
          const active = location.pathname === path;
          return (
            <button key={path} style={styles.navBtn} onClick={() => navigate(path)}>
              <Icon size={22} color={active ? '#FF6B35' : '#7F8C8D'} strokeWidth={active ? 2.5 : 1.8} />
              <span style={{ ...styles.navLabel, color: active ? '#FF6B35' : '#7F8C8D', fontWeight: active ? 600 : 400 }}>
                {label}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', flexDirection: 'column', background: '#FAFAFA' },
  header: {
    background: 'white',
    padding: '16px 20px',
    borderBottom: '1px solid #ECF0F1',
    position: 'sticky',
    top: 0,
    zIndex: 100,
    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
  },
  title: { fontSize: '18px', fontWeight: '700', color: '#2C3E50' },
  main: { flex: 1, padding: '16px', paddingBottom: '80px', maxWidth: '600px', margin: '0 auto', width: '100%' },
  nav: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: 'white',
    borderTop: '1px solid #ECF0F1',
    display: 'flex',
    padding: '8px 0 4px',
    zIndex: 100,
    boxShadow: '0 -4px 12px rgba(0,0,0,0.08)',
  },
  navBtn: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '3px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '4px 0',
  },
  navLabel: { fontSize: '10px' },
};
